(() => { 
  const listener = () => {
    const mapurl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA4JSDK56vznaHbgaIeA_Zphn4GEKZji34&callback=initMap&loading=async&libraries=marker,routes';
    if(window.matchMedia('(min-width: 590px)').matches) {
      loadJS(mapurl);
    } else {
      if(pageLoaded) {
        loadJS(mapurl);
      } else {
        window.addEventListener('load',loadJS(mapurl));
      }
    }
  }; 

  let currentPosition;

  window.initMap = () => {
    const warehouses = [
      {position:{lat: 54.33584847302902, lng: -2.742720718467441}, content:'Catering Appliance Superstore,<br />Mintsfeet Road South,<br />Mintsfeet Industrial Estate,<br />Kendal,<br />Cumbria,<br />UK, LA9 6ND'}
    ];

    let sform = '<form id="mapsearch"><button id="getLocation" class="btn">Get my location</button><label for="searchField">Get Directions from</label><input type="text" name="searchField" id="searchField" /><button class="btn">Search</button></form>';

    let bounds = new google.maps.LatLngBounds();
    let infowindow = new google.maps.InfoWindow();
    const markers = [];
    let lastMarker = warehouses[0]; 
    let directionsService;
    let directionsRenderer;

    const map = new google.maps.Map(document.getElementById('map'), {
      maxZoom: 16,
      mapId: 'CandCMap'
    });

    const caicon = document.createElement('img');
    caicon.src = asc+'/shop/img/ca-marker.png';
    caicon.className = 'camarker';
    caicon.alt = 'Catering Appliance Warehouse';

    const doticon = document.createElement('img');
    doticon.src = asc+'/shop/img/bluedot.png';
    doticon.className = 'dotmarker';
    doticon.alt = 'Current Location';

    const getCurrentLocation = (e) => {
      if(e) {
        e.preventDefault();
      }
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
              const latitude = position.coords.latitude;
              const longitude = position.coords.longitude;
              const accuracy = position.coords.accuracy;
              currentPosition = new google.maps.LatLng(latitude, longitude);
              
              bounds.extend(currentPosition);
              map.fitBounds(bounds);

              const marker = new google.maps.marker.AdvancedMarkerElement({
                  position: currentPosition,
                  map: map,
                  content: doticon.cloneNode(),
                  title: doticon.alt
              });
              qs('#searchField').setAttribute('placeholder', 'Current Location');
          },
          msg => {alert('Please enable your GPS position feature.');},
          {
            maximumAge:10000, timeout:5000, enableHighAccuracy: true
          });
      } else {
          alert("Geolocation API is not supported in your browser.");
      }
    }

    let startPoint, startMarker, mapPolylines;

    const getDirections = async e => {
      e.preventDefault();
      const inp = qs('#searchField');
      if(inp.value.length > 0 || (currentPosition && inp.value.length == 0)) {
        const directionsPanel = qs('#directions');
        const request = {
          origin:inp.value.length > 0?inp.value:currentPosition,
          destination:lastMarker.position,
          travelMode:'DRIVING',
          fields: ['legs']
        };

        if(startMarker) {
          startMarker.setMap(null);
        }
        if(mapPolylines) {
          mapPolylines.forEach((polyline) => polyline.setMap(null));
        }

        const { Route } = await google.maps.importLibrary("routes");
        const { routes, fallbackInfo, geocodingResults } = await Route.computeRoutes(request);
        mapPolylines = routes[0].createPolylines();
        mapPolylines.forEach((polyline) => polyline.setMap(map));
        const markerBounds = new google.maps.LatLngBounds();
        startPoint = routes[0].legs[0].startLocation;
        startMarker = new google.maps.marker.AdvancedMarkerElement({
          map,
          position: startPoint,
          content: new google.maps.marker.PinElement({
            glyphText: "1",
            glyphColor:'#415161',
            background:'#fff',
            borderColor:'#007ba4'
          })
        });

        startMarker.setMap(map);
        markerBounds.extend(startMarker.position);
        markerBounds.extend(lastMarker.position);
        map.fitBounds(markerBounds);

        if (!routes || routes.length === 0) {
          if (directionsPanel) {
            directionsPanel.textContent = "No routes available.";
          }
        }

        const route = routes[0];
        if (!route.legs || route.legs.length === 0) {
          if (directionsPanel) {
            directionsPanel.textContent = "The route has no legs.";
          }
          return;
        }

        const fragment = document.createDocumentFragment();
        directionsPanel.textContent = '';
        function msToTime(s) {
          var ms = s % 1000;
          s = (s - ms) / 1000;
          var secs = s % 60;
          s = (s - secs) / 60;
          var mins = s % 60;
          var hrs = (s - mins) / 60;

          let times = [];
          if(hrs>0) 
            times.push(`${hrs} hours`)
          if(mins>0) 
            times.push(`${mins} minutes`)


          return times.length == 1?times:times.join(' and ');
        }
        route.legs.forEach((leg, index) => {
          const legContainer = document.createElement("div");
          legContainer.className = "directions-leg";
          legContainer.setAttribute("aria-label", `Leg ${index + 1}`);

          if(route.legs.length > 1) {
            const legTitleElement = document.createElement("h3");
            legTitleElement.textContent = `Leg ${index + 1} of ${route.legs.length}`;
            legContainer.appendChild(legTitleElement);
          }
          
          const legEstElement = document.createElement("h4");
          legEstElement.textContent = `Estimated Journey Time: ${msToTime(leg.durationMillis)}`;
          legContainer.appendChild(legEstElement);

          if (leg.steps && leg.steps.length > 0) {
            const stepsList = document.createElement("ol");
            stepsList.className = "directions-steps";

            leg.steps.forEach((step, stepIndex) => {
              const stepItem = document.createElement("li");
              stepItem.className = "direction-step";
              stepItem.setAttribute("aria-label", `Step ${stepIndex + 1}`);

              if (step.maneuver) {
                const maneuverNode = document.createElement("div");
                maneuverNode.className = "maneuver "+step.maneuver.toLowerCase();
                const maneuverHolder = document.createElement("p");
                maneuverHolder.appendChild(maneuverNode);
                stepItem.appendChild(maneuverHolder);
              }

              if (step.localizedValues) {
                const distanceNode = document.createElement("p");
                distanceNode.textContent = `${step.localizedValues.distance} (${step.localizedValues.staticDuration})`;
                distanceNode.className = "distance";
                stepItem.appendChild(distanceNode);
              }

              if (step.instructions) {
                const instructionsNode = document.createElement("p");
                instructionsNode.textContent = step.instructions;
                instructionsNode.className = "instruction";
                stepItem.appendChild(instructionsNode);
              }

              stepsList.appendChild(stepItem);
            });
            legContainer.appendChild(stepsList);
          }

          fragment.appendChild(legContainer);
          directionsPanel?.appendChild(fragment);
        });
      } else {
        alert('Please enter where you would be coming from');
      }
      return false;
    }

    const addMarker = i => {
      bounds.extend(warehouses[i].position);
      var marker = new google.maps.marker.AdvancedMarkerElement({
        position: warehouses[i].position,
        map: map,
        content: caicon.cloneNode(),
        title: caicon.alt
      });
      marker.addListener('gmp-click',() => {
        if(infowindow) {
          infowindow.close();
        }
        lastMarker = warehouses[i];
        infowindow = new google.maps.InfoWindow({position:warehouses[i].position, content:warehouses[i].content + (warehouses.length > 1?sform:'')});
        infowindow.open({map:map});

        if(warehouses.length > 1) {
          const ms = document.getElementById('mapsearch');
          ms.addEventListener('submit', getDirections);
          const gl = qs('#getLocation');
          if(gl) {
            gl.addEventListener('click',getCurrentLocation);
          }
        }
      });
      markers.push(marker);
    }

    for(var i = 0; i < warehouses.length; i++) {
      addMarker(i);
    }

    if(markers.length == 1) {
      const sf =  qs('#searchform');
      sf.innerHTML = sform;
      qs('#mapsearch',sf).addEventListener('submit',getDirections);
      const gl = qs('#getLocation',sf);
      if(gl) {
        gl.addEventListener('click',getCurrentLocation);
      }
    }

    map.fitBounds(bounds);
  }

  if(scriptReady) {
    listener();
  } else {
    if(document.addEventListener) { 
      document.addEventListener('scriptReady', listener);
    } else { 
      document.attachEvent('scriptReady', listener);
    };
  }
})();